import { DateTime } from "luxon";
import { useCallback, useState } from "react";
import useGetCurrentUnityStatus from "@features/unified-user-header-feature/hooks/useGetCurrentUnityStatus";
import {
  useGetUserConfig,
  useUpsertUserConfig,
} from "../modules/hooks/useUserConfig";
import { UserConfigDto } from "@lib/ShiOneClient";

export const UNIFICATION_BANNER_DISMISSED_KEY =
  "unification-announcement-dismissed";

/** The banner stops displaying after this date. */
const BANNER_EXPIRY_DATE = DateTime.fromISO("2026-07-15", { zone: "utc" });

export function useAnnouncementBanner() {
  const { data: unityStatus, isLoading: unityStatusLoading } =
    useGetCurrentUnityStatus();

  const { userConfig, isLoading: configLoading } = useGetUserConfig(
    UNIFICATION_BANNER_DISMISSED_KEY,
  );

  const upsertUserConfig = useUpsertUserConfig();


  const [isDismissedLocally, setIsDismissedLocally] = useState(false);
  const isEligible = unityStatus?.isEligibleForUnity === true;
  const isBannerExpired = DateTime.now() >= BANNER_EXPIRY_DATE;

  const isDismissedOnServer = userConfig?.settingsValue === "true";
  const isLoading = unityStatusLoading || configLoading;


  const isVisible =
    !isLoading &&
    isEligible &&
    !isBannerExpired &&
    !isDismissedLocally &&
    !isDismissedOnServer;


  const handleDismiss = useCallback(() => {
    setIsDismissedLocally(true);

    const settings = new UserConfigDto();
    settings.settingsKey = UNIFICATION_BANNER_DISMISSED_KEY;
    settings.settingsValue = "true";

    upsertUserConfig.mutate(settings, {
      onError: () => {
        setIsDismissedLocally(false);
      },
    });
  }, [upsertUserConfig]);

  return { isVisible, isLoading, handleDismiss };
}
